<mat-divider style="margin-top: 5px"></mat-divider>
@if (input().param.type === 'Table') {
  <div class="table-container">
    <h4>{{ input().displayName }}</h4>
    <div class="input-description">
      {{ input().description }}
    </div>
    <app-dynamic-table
      (selectionChanged)="onSelectionChanged($event)"
      [editType]="tableEditType()"
      [allowEdit]="isEditable()"
      [modificationSettings]="modificationSettings()"
      [allowSelection]="isSelectable()"
      [allowMultiSelect]="input().isList"
      [columns]="columnDef()"
      [data]="tableData()"></app-dynamic-table>
  </div>
}
<mat-divider style="margin: 20px 0"></mat-divider>
